import React from 'react'

import { withRouter } from 'react-router-dom'
import { Chart } from 'primereact/chart';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Badge } from 'primereact/badge';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Calendar } from 'primereact/calendar'
import { Toast } from 'primereact/toast';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import NavBar from '../../componentes/Navbar'

import GraficoAtividadeService from '../../app/service/GraficoAtividadeService'
import FinanceiroService from '../../app/service/FinanceiroService'
import UsuarioService from '../../app/service/UsuarioService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './grafico.css'
import '../processo/processo.css'

class DesempenhoUsuario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      atividades: [],
      nomeUsuario: '',
      usuario: null,
      data: '',
      tipoConsulta: '',
      pontosTotal: '',
      pontosConcluidos: '',
      openSpinner: false,
      detail: ''
    };

    this.usuarioService = new UsuarioService();
    this.graficoAtividadeService = new GraficoAtividadeService();
  }

  consultarAtividades = async (usuario,dataInicial,dataFinal,tipoConsulta) => {
    await this.graficoAtividadeService.consultarAtividadesPorUsuario(usuario,dataInicial,dataFinal,tipoConsulta)
      .then(response => {
        this.setState({atividades: response.data});
        let pTotal = 0;
        let pConcluido = 0;
        for(let i = 0; i < response.data.length; i++) {
          if(response.data[i].status == 'Concluído') {
            pConcluido = pConcluido + response.data[i].pontos;
          }

          pTotal = pTotal + response.data[i].pontos;
        }
        this.setState({pontosConcluidos: pConcluido});
        this.setState({pontosTotal: pTotal});

      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarUsuario = async (codigo) => {
    await this.usuarioService.consultarUsuario(codigo)
      .then(response => {
        this.setState({usuario: response.data});
        this.setState({nomeUsuario: response.data.nome});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    const params = this.props.match.params;
    if(params.codigoUsuario) {
      const dataInicial = this.formatarData(params.dataInicial);
      const dataFinal = this.formatarData(params.dataFinal);
      this.setState({data: dataInicial + " a " + dataFinal});
      if(params.tipoConsulta == 'C') {
        this.setState({tipoConsulta: 'Atividades Concluídas'});
      } else {
        this.setState({tipoConsulta: 'Atividades Criadas'});
      }
      await this.consultarUsuario(params.codigoUsuario);
      await this.consultarAtividades(params.codigoUsuario,params.dataInicial,params.dataFinal,params.tipoConsulta);
    }
    this.setState({openSpinner: false});
  }

  formatarData(dataOriginal) {
    const [ano, mes, dia] = dataOriginal.split('-').map(Number);
    const data = new Date(ano, mes - 1, dia);
    const diaFormatado = data.getDate().toString().padStart(2, '0');
    const mesFormatado = (data.getMonth() + 1).toString().padStart(2, '0');
    const anoFormatado = data.getFullYear();
    return `${diaFormatado}/${mesFormatado}/${anoFormatado}`;
  }

  render() {
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fa fa-id-card"></i>
                            <span>&nbsp;Desempenho individual detalhado de usuário: &nbsp;&nbsp;<strong style={{color: 'blue'}}>{this.state.nomeUsuario}</strong></span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="card">
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="formGroup">
                                <label>Data Pesquisa:&nbsp;<strong style={{color: 'blue'}}>{this.state.data}</strong></label>
                                <br />
                                <label style={{color: 'blue'}}>{this.state.tipoConsulta}</label>
                                <br />
                                <label>Total Pontos:&nbsp;<strong style={{color: 'blue'}}>{this.state.pontosTotal}</strong></label>
                                <br />
                                <label>Total Pontos Concluídos:&nbsp;<strong style={{color: 'blue'}}>{this.state.pontosConcluidos}</strong></label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-12">
                            <DataTable value={this.state.atividades}>
                              <Column field="atividade" header="Atividade"></Column>
                              <Column field="pontos" header="Pontos"></Column>
                              <Column field="dataRegistro" header="Data Registro"></Column>
                              <Column field="dataLimite" header="Data Limite"></Column>
                              <Column field="dataFatal" header="Data Fatal"></Column>
                              <Column field="dataConcluido" header="Data Conclusão"></Column>
                              <Column field="status" header="Status"></Column>
                              <Column field="processo" header="Proceso"></Column>
                              <Column field="fase" header="Fase Processual"></Column>
                            </DataTable>
                          </div>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </>
    );
  }
}
DesempenhoUsuario.contextType = AuthContext;
export default withRouter (DesempenhoUsuario)

